module.exports = __webpack_public_path__ + "img/11825388_L.74a3771d.png";